import React, {Component} from 'react';
import axios from "axios";
import Cookies from "universal-cookie";
import {inject, observer} from "mobx-react";
import _ from 'lodash';

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography/Typography";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";

import './ATGDashboard.scss'
import {FETCH_URL} from "../../constants/ServerLinks";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import {withStyles} from "@material-ui/core";

const styles = () => ({
    linearColorPrimary: {
        backgroundColor: 'rgba(35, 45, 75, 0.2)',
        height: 12,
    },
    linearBarColorPrimary: {
        backgroundColor: '#232d4b',
        height: 12,
    },
    linearColorSecondary: {
        backgroundColor: 'rgba(229, 114, 0, 0.2)',
        height: 12,
    },
    linearBarColorSecondary: {
        backgroundColor: '#e57200',
        height: 12,
    },
});

@observer
class ATGDashboard extends Component {

    constructor(props) {
        super(props);

        this.fetchURL = FETCH_URL;
        this.cookies = new Cookies();
        this.worldId = this.cookies.get('world_id');
        this.roleAlias = this.cookies.get('role_alias');
        this.state = {
            selected: '',
            queues: {},
            submissions: {},
            lastUpdated: {},
            isUpdated: {},
        };

        // Fetch the policy queues and submissions
        this.fetchQueuesAndSubmissions();
    }

    fetchQueuesAndSubmissions = () => {

        axios.all([
            // axios.get(this.fetchURL + '/api/v1/policies/queue/', {
            //     params: {
            //         world_id: this.worldId,
            //         timestamp: this.state.lastUpdated,
            //     }
            // }),
            axios.get(this.fetchURL + '/api/v1/policies/submissions/', {
                params: {
                    world_id: this.worldId,
                    timestamp: this.state.lastUpdated,
                }
            })
        ])
            .then(axios.spread((submissionResponse) => {

                // console.group("ATGDashboard:fetchQueuesAndSubmissions");
                // console.log(qResponse.data.data);
                // console.log(submissionResponse.data.data);
                // console.groupEnd();

                if (submissionResponse.data.success) {
                    // let queues = qResponse.data.data;
                    let submissions = submissionResponse.data.data;

                    if (!_.isEqual(this.state.lastUpdated, submissions.timestamp)) {

                        // let qs = {};
                        let subs = {};
                        let iup = {};
                        // Update the queues and submissions of the countries with updated timestamp
                        Object.keys(submissions.timestamp).forEach((country) => {
                            if (this.state.lastUpdated[country] !== submissions.timestamp[country]) {
                                // qs[country] = queues.queue[country];
                                subs[country] = submissions.submission[country];
                                iup[country] = true;
                            } else {
                                // qs[country] = this.state.queues[country];
                                subs[country] = this.state.submissions[country];
                                iup[country] = false;
                            }
                        });

                        this.setState(() => {
                            return {
                                // queues: qs,
                                lastUpdated: submissions.timestamp,
                                submissions: subs,
                                isUpdated: iup,
                            }
                        });
                    }
                }
            }))
            .catch((error) => {
                console.log(error);
            });
    };

    countrySelected = (e, country) => {
        e.preventDefault();

        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });

        if(this.state.selected === country){
            this.setState((prevState) => (
                {
                    selected: '',
                    isUpdated: Object.assign({}, prevState.isUpdated, prevState.isUpdated[country] = false),
                }
            ));
        } else {
            this.setState((prevState) => (
                {
                    selected: country,
                    isUpdated: Object.assign({}, prevState.isUpdated, prevState.isUpdated[country] = false),
                }
            ));
        }
    };

    shouldComponentUpdate = (nextProps) => {

        if (nextProps.updateDashboard === true) {
            this.fetchQueuesAndSubmissions();
        }
        return true;
    };

    render() {
        const {policies, classes} = this.props;
        const categories = [...new Set(policies.policies.map(pol => pol.category))];
        return (
            <div className={`dash__wrap ${this.props.display === "show" ? "active" : "hidden"}`}>
                <div className="dash__outer">

                    <div className="header__flagATG flex flex-wrap">
                        {Object.keys(this.state.submissions).sort().map((item, index) => {
                            return (
                                <div onClick={(e) => this.countrySelected(e, item)}
                                     className={`header__roleWrap ${this.state.selected === item ? "active" : ""}`}
                                     key={index}>
                                    <div className="header__countryInner">
                                        <div className={`dashboard__countryFlag container icon${item}`}/>
                                        <h4>{item}</h4>
                                        <h6 className={this.state.isUpdated[item] && this.state.selected === item ? 'notify' : 'update-notify'}>
                                            {this.state.isUpdated[item] && '* New *'}
                                        </h6>
                                    </div>
                                </div>
                            )
                        })
                        }
                    </div>

                    <div className="header__flagATGPadding"/>

                    {this.state.submissions !== {} ? // || this.state.queues !== {} ?
                        Object.keys(this.state.submissions).map((item, index) => {
                            // const polQ = this.state.queues[item];
                            const polS = this.state.submissions[item][0];
                            // const refYear = Object.keys(polQ).sort()[Object.keys(polQ).length - 1];
                            const polSlen = Object.keys(polS).length;

                            return (
                                <div
                                    className={`dash__inner dash__roleWiki ${this.state.selected === item ? "active" : "hidden"}`}
                                    key={index}>
                                    <div className="dash__panel">
                                        <div className="dash__panelWrap oh shadow w10 p2">

                                            <div className="pt2">
                                                <h3>Policies In Play</h3>
                                                {(Array.isArray(Object.values(polS)[0]) && Object.values(polS)[0].length)
                                                // || (Array.isArray(Object.values(polQ)[0]) && Object.values(polQ)[0].length)
                                                ?

                                                    <div className="container p1">
                                                        {
                                                            categories.map((cat, index) => {
                                                                const policyList = policies.policies.filter(pol => pol.category === cat && pol.country_name === item && pol.category !== this.roleAlias);

                                                                return (
                                                                    cat !== this.roleAlias ? <ExpansionPanel key={`drawerCat-${index}`}
                                                                                    defaultExpanded={true}>
                                                                        <ExpansionPanelSummary
                                                                            expandIcon={<ExpandMoreIcon/>}>
                                                                            <Typography variant={"display1"}>
                                                                                <strong>{cat}</strong>
                                                                            </Typography>
                                                                        </ExpansionPanelSummary>
                                                                        <ExpansionPanelDetails>

                                                                            <table className="polTable">
                                                                                <thead>
                                                                                <tr>
                                                                                    <th className="polName">Policies</th>
                                                                                    {Object.keys(polS).map((year, yIndex) => (
                                                                                        <th key={`drawer-${year}`}
                                                                                            className={yIndex === polSlen - 1 ? 'currYear': ''}>
                                                                                            {year}</th>
                                                                                    ))}
                                                                                    {/*{!cat.includes("ATG") &&*/}
                                                                                    {/*<th className={"proposed"}>Proposals</th>}*/}
                                                                                    {/*<th>&nbsp;</th>*/}
                                                                                </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                {policyList.map(pol => {
                                                                                    let currPol = {};
                                                                                    return (
                                                                                        <tr key={`atg-${pol.id}`}>
                                                                                            <td>{pol.name}</td>
                                                                                            {Object.keys(polS).map((year, pIndex) => {
                                                                                                const p = polS[year].find(item => item[0] === pol.id);
                                                                                                if (pIndex === polSlen - 1) {
                                                                                                    currPol = p;
                                                                                                }
                                                                                                const dist = p[2] && 'R: ' + (parseFloat(p[2][0]) * 100).toFixed(0) + '% S:' + (parseFloat(p[2][1]) * 100).toFixed(0) + '% H:' + (parseFloat(p[2][2]) * 100).toFixed(0) + '%';

                                                                                                return (
                                                                                                    <td key={`pd-year-${year}`}>
                                                                                                        {dist ? dist : pol.values[p[1]]}
                                                                                                    </td>
                                                                                                )
                                                                                            })}
                                                                                            {/*{!cat.includes("ATG") &&*/}
                                                                                            {/*<td>{pol.values[polQ[refYear][pol.id]]}</td>}*/}
                                                                                            {/*<td className={"polIntensity"}>*/}
                                                                                                {/*{Object.keys(pol.values).length >= 2 &&*/}
                                                                                                {/*<div>*/}
                                                                                                    {/*<LinearProgress*/}
                                                                                                        {/*variant="determinate"*/}
                                                                                                        {/*classes={{*/}
                                                                                                            {/*colorPrimary: classes.linearColorPrimary,*/}
                                                                                                            {/*barColorPrimary: classes.linearBarColorPrimary,*/}
                                                                                                        {/*}}*/}
                                                                                                        {/*value={(parseFloat(parseInt(currPol[1]) - 1) / (Object.keys(pol.values).length - 1)) * 100}/>*/}
                                                                                                    {/*<LinearProgress*/}
                                                                                                        {/*variant="determinate"*/}
                                                                                                        {/*classes={{*/}
                                                                                                            {/*colorPrimary: classes.linearColorSecondary,*/}
                                                                                                            {/*barColorPrimary: classes.linearBarColorSecondary,*/}
                                                                                                        {/*}}*/}
                                                                                                        {/*value={polQ[refYear][pol.id] ? (parseFloat(parseInt(polQ[refYear][pol.id]) - 1) / (Object.keys(pol.values).length - 1)) * 100 : 0}/>*/}
                                                                                                {/*</div>*/}

                                                                                                {/*}*/}
                                                                                            {/*</td>*/}
                                                                                        </tr>
                                                                                    )
                                                                                })}
                                                                                </tbody>
                                                                            </table>

                                                                        </ExpansionPanelDetails>
                                                                    </ExpansionPanel> : null 
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                    :
                                                    <h4>No Policies.</h4>
                                                }
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )
                        })
                        : null}
                </div>
            </div>
        )
    }
}

export default withStyles(styles)(inject('policies')(ATGDashboard));
